import * as moment from "moment";

const nullFilterValue: string = "NULL";

interface IListColumnFilterBindings {
    filterValues: string[];
    selectedFilters: { [value: string]: boolean };
    filterDataTypeId: number;
    onApplyFilters: (IOnApplyFiltersEvent) => void;
    groupName: string;
    tagLabel: string;
    disableFiltering: boolean;
}

export class RLListColumnFilterController implements IListColumnFilterBindings {
    public static $inject = ["$scope"];
    public filterValues: string[];
    public selectedFilters: { [value: string]: boolean };
    private allFilters: IFilterItem[];
    public workingFilters: IFilterItem[];
    public filter: string = "";
    public allSelected: boolean;
    public filterDataTypeId: number;
    public disableFiltering: boolean;
    public groupName: string;
    public tagLabel: string;
    public isOpen: boolean;
    public onApplyFilters: (IOnApplyFiltersEvent) => void;

    private readonly _formatStrategies: { [dateTypeId: number]: (value: string) => string } = {
        5: (value) => {
            let parsed = moment.utc(value);
            if (!parsed.isValid()) {
                return value;
            }
            return parsed.format("L");
        }
    };

    public constructor($scope: ng.IScope) {
        $scope.$watch(() => this.workingFilters, (newValue) => {
            if (newValue && this.filterValues) {
                let deselectedFilters = newValue.filter(x => !x.toggle);
                this.allSelected = !_.any(deselectedFilters);
            }
        }, true);
    }

    public filterValueComparer(left: any, right: any) {
        let leftFilter = left.value as IFilterItem;
        let rightFilter = right.value as IFilterItem;

        // places the Null option at the bottom of the filters
        if (leftFilter.value === nullFilterValue) {
            return 1;
        } else if (rightFilter.value === nullFilterValue) {
            return -1;
        }

        return leftFilter.label.localeCompare(rightFilter.label);
    }

    public $onInit() {
        this.allFilters = Object.keys(this.selectedFilters)
            .map<IFilterItem>(value => {
                // Formats the label here so that we can search the formatted label in the view
                let formattedLabel = this.formatValue(value, this.filterDataTypeId);
                return { value: value, label: formattedLabel, toggle: this.selectedFilters[value] };
            });

        // Sets the label of the null filter item to empty
        let nullFilterItem = this.allFilters.find(x => x.value == nullFilterValue);
        if (nullFilterItem) {
            nullFilterItem.label = "[empty]";
        }

        // the working filters must have a unique set of labels
        this.workingFilters = this.allFilters.reduce<IFilterItem[]>((filters, next) => {
            let found = filters.find(x => x.label == next.label)
            if (!found) {
                filters.push(next);
            }
            return filters;
        }, []);
    }

    public toggleSelectAllFilters(toggleValue: boolean) {
        this.workingFilters = this.workingFilters.map(filter => {
            filter.toggle = toggleValue;
            return filter;
        });
    }

    public applyFilters() {
        let selected = this.allFilters.reduce<{ [value: string]: boolean }>(
            (selected, next) => {
                // we match on labels here in case we have duplicated labels in the all filters list
                let workingFilter = this.workingFilters.find(x => x.label === next.label);
                selected[next.value] = workingFilter.toggle;
                return selected;
            }, {});

        let event: IOnApplyFiltersEvent = { selectedFilters: selected, groupName: this.groupName, tagLabel: this.tagLabel };
        this.onApplyFilters({ $event: event });
        this.isOpen = false;
    }

    private formatValue(value: string, dataTypeId: number) {
        if (this._formatStrategies[dataTypeId]) {
            return this._formatStrategies[dataTypeId](value);
        }
        return value;
    }
}

interface IFilterItem {
    value: string;
    toggle: boolean;
    label: string;
}

export interface IOnApplyFiltersEvent {
    groupName: string;
    tagLabel: string;
    selectedFilters: { [value: string]: boolean };
}

export class RLListColumnFilter implements angular.IComponentOptions {
    public bindings: any = {
        filterValues: "<",
        selectedFilters: "<",
        filterDataTypeId: "<",
        onApplyFilters: "&",
        groupName: "<",
        tagLabel: "<",
        disableFiltering: "<"
    };
    public controller: any = RLListColumnFilterController;
    public controllerAs: string = "lcfVM";
    public transclude: boolean = false;
    public template: string = require("./list-column-filter.component.html");
}